import React, { useEffect, useMemo, useState } from 'react'
import Select from 'react-select'
import AgentProfileCard from './AgentProfileCard';
import Msg from "../../../components/Msg";
import { useTranslation } from 'react-i18next';
import { useCurrentAccount } from '../../../hooks/useCurrentAccount';
import { FollowUpService } from '../../../services/FollowUpService';
import { AgentsService } from '../../../services/AgentsService';
import { SubAccountService } from '../../../services/SubaccountService';
import useRequest from '../../../hooks/useRequest';
import Loader from '../../../components/Loader';

export default function SideBar() {
    const { t } = useTranslation();
    const { account } = useCurrentAccount();
    const {call, isRequesting} = useRequest();
    const [agents, setAgents] = useState([]);
    const [subaccounts, setsubaccounts] = useState([]);
    const [term, setTerm] = useState('');
    const [newAgents, setnewAgents] = useState([]);
    const [selectedSubAccount, setselectedSubAccount] = useState([]);
    const [selectedStatusAgent, setselectedStatusAgent] = useState([]);
    const [statusAgents, setstatusAgents] = useState([]);
    const [CheckboxStates, setCheckboxStates] = useState({ 'online': false, 'offline': false });
    const [activeFilters, setactiveFilters] = useState({ 'online': false, 'offline': false });
    const [filterSubAccount, setfilterSubAccount] = useState([]);
    const [filterStatusAgent, setfilterStatusAgent] = useState([]);

    const getAgentsData = async () => {
        const { data } = await call(() => FollowUpService.getAgents(account.id));
        setAgents(data);
    }
    const getSubAccounts = async () => {
        const { data } = await SubAccountService.getSubaccounts(account.id);
        setsubaccounts(data.sub_accounts.map(subaccount => ({
            value: subaccount.id,
            label: subaccount.name
        })));
    };
    const getStatusAgnets = async () => {
        const { data } = await AgentsService.getStatuses(account.id);
        setstatusAgents(data.all_status.map(statusAgnet => ({
            value: statusAgnet.id,
            label: statusAgnet.name
        })));
    };

    useEffect(() => {
        getAgentsData();
        getSubAccounts();
        getStatusAgnets();
    }, []);

    useEffect(() => {
        applyFilters();
    }, [agents, term]);

    const apply = () => {
        setactiveFilters({
            online: CheckboxStates.online,
            offline: CheckboxStates.offline,
        });
        setfilterSubAccount(selectedSubAccount);
        setfilterStatusAgent(selectedStatusAgent);
        applyFilters();
    };

    const applyFilters = () => {
        let filteredAgents = agents.filter(agent => {
            // Filtro por estado online/offline
            let statusFilter = (CheckboxStates.online && agent.status === 'Online') ||
                (CheckboxStates.offline && agent.status === 'Offline') ||
                (CheckboxStates.online && CheckboxStates.offline) ||
                (!CheckboxStates.online && !CheckboxStates.offline);


            // Filtro por subcuentas seleccionadas
            let subAccountFilter = selectedSubAccount.length > 0 ?
                selectedSubAccount.some(selected => agent.sub_account === selected.label) :
                true;


            // Filtro por estados de agente seleccionados
            let statusAgentFilter = selectedStatusAgent.length > 0 ?
                selectedStatusAgent.some(selected => agent.status_table ? agent.status_table === selected.label : false) :
                true;

            return statusFilter && subAccountFilter && statusAgentFilter;
        });

        // Filtro adicional por término de búsqueda
        filteredAgents = filteredAgents.filter(agent =>
            agent?.username.toLowerCase().includes(term.toLowerCase()) ||
            (agent?.sub_account && agent.sub_account.toLowerCase().includes(term.toLowerCase())) ||
            (agent?.status_table && agent.status_table.toLowerCase().includes(term.toLowerCase()))
        );

        setnewAgents(filteredAgents);
    };


    const verifyFilters = () => {
        setCheckboxStates({
            online: activeFilters.online,
            offline: activeFilters.offline,
        });
        setselectedSubAccount(filterSubAccount);
        setselectedStatusAgent(filterStatusAgent);
    };

    const changeOnlineHandler = () => {
        setCheckboxStates({
            ...CheckboxStates,
            online: !CheckboxStates.online
        });
    }
    const changeOfflineHandler = () => {
        setCheckboxStates({
            ...CheckboxStates,
            offline: !CheckboxStates.offline
        });
    }
    const handleSelectChange = (selectedOptions) => {
        setselectedSubAccount(selectedOptions || []);
    };
    const handleSelectChangeStatus = (selectedOptions) => {
        setselectedStatusAgent(selectedOptions || []);
    };

    const handleClearFilters = (event) => {
        event.stopPropagation();
        setCheckboxStates({ 'online': false, 'offline': false });
        setactiveFilters({ 'online': false, 'offline': false });
        setfilterSubAccount([]);
        setfilterStatusAgent([]);
        setselectedSubAccount([]);
        setselectedStatusAgent([]);
        setnewAgents([...agents]);
    };


    return (
        <div className='col-3 border border-end-0 p-0'>
            <div >
                <div className="d-flex  m-0 border-bottom px-3 py-21">
                    <div className=" input-group input-group-merge p-0 me-2">
                        <div className="input-group-prepend input-group-text">
                            <i className="bi-search"></i>
                        </div>
                        <input type="search" className="form-control h-34 font-12 " placeholder={t("components.custom-table.filter")} onChange={({ target: { value } }) => setTerm(value)} value={term} />
                    </div>
                    <div className="dropdown">
                        <button type="button" className="btn btn-white btn-sm w-100 text-nowrap" id="usersFilterDropdown" data-bs-toggle="dropdown" aria-expanded="false" onClick={verifyFilters}>
                            <i className="bi-ui-radios me-1"></i> {t("follow-up.sidebar.filter-btn")}
                        </button>
                        <div className="dropdown-menu dropdown-menu-sm-end dropdown-card card-dropdown-filter-centered" aria-labelledby="usersFilterDropdown" style={{ minWidth: "20rem" }}>
                            <div className="card">
                                <div className="card-header card-header-content-between">
                                    <h5 className="card-header-title">{t("follow-up.sidebar.filter-dropdown-title")}</h5>

                                    <button type="button" className="btn  btn-icon btn-sm ms-2">
                                        <i className="bi-x-lg"></i>
                                    </button>
                                </div>
                                <div className="card-body">
                                    <form>
                                        <div className="mb-4">
                                            <small className="text-cap text-body">{t("follow-up.sidebar.filter-dropdown_eAgent")} </small>
                                            <div className="row">
                                                <div className="col">
                                                    <div className="form-check">
                                                        <input className="form-check-input" type="checkbox" value="" id="online" onChange={changeOnlineHandler} checked={CheckboxStates.online} />
                                                        <label className="form-check-label text-nowrap" htmlFor="usersFilterCheckAll">
                                                            {t("follow-up.sidebar.filter-dropdown_eAgentOnline")}
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="col">
                                                    <div className="form-check">
                                                        <input className="form-check-input" type="checkbox" value="" id="offline" onChange={changeOfflineHandler} checked={CheckboxStates.offline} />
                                                        <label className="form-check-label text-nowrap" htmlFor="usersFilterCheckEmployee">
                                                            {t("follow-up.sidebar.filter-dropdown_eAgentOffline")}
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="mb-4">
                                            <small className="text-cap text-body">{t("follow-up.sidebar.filter-dropdown_ASubaccount")}</small>
                                            <div className="row" onClick={(e) => e.stopPropagation()}>
                                                <div className="col">
                                                    <Select
                                                        isMulti
                                                        options={subaccounts}
                                                        value={selectedSubAccount}
                                                        onChange={handleSelectChange}
                                                        placeholder={t("follow-up.sidebar.filter-dropdown_ASubaccountPh")}
                                                        className={'tom-select-custom tom-select-custom-with-tags'}
                                                        classNamePrefix='form-select-custom'
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="mb-4">
                                            <small className="text-cap text-body">{t("follow-up.sidebar.filter-dropdown_AStatus")}</small>
                                            <div className="row" onClick={(e) => e.stopPropagation()}>
                                                <div className="col">
                                                    <Select
                                                        isMulti
                                                        options={statusAgents}
                                                        value={selectedStatusAgent}
                                                        onChange={handleSelectChangeStatus}
                                                        placeholder={t("follow-up.sidebar.filter-dropdown_AStatusPh")}
                                                        className={'tom-select-custom tom-select-custom-with-tags'}
                                                        classNamePrefix='form-select-custom'
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="d-grid">
                                            <a className="text-cap btn btn-link text-danger text-nowrap" onClick={handleClearFilters} style={{ fontSize: '10px', marginLeft: '60%' }}>{t("follow-up.sidebar.filter-dropdown_clearF")}</a>
                                            <a className="btn btn-primary" onClick={apply}>{t("follow-up.sidebar.filter-dropdown_aply")}</a>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
            <div className='overflow-scroll sidebar relative'>
                {
                    isRequesting ? <Loader/>:
                    newAgents.length > 0 ? 
                    newAgents.map(d => <AgentProfileCard data={d} key={d.agent_id} />) : <Msg />
                }
            </div>
        </div >

    )
}
